<template>
  <div class="selection">
    <div class="selection__row" @click="toggleExpanded">
      <div class="selection__square">
        <slot name="icon" />
      </div>
      <div class="selection__right">
        <div class="selection__right__inner">
          <div>
            <p>{{ title }}</p>
            <p>
              {{
                expanded
                  ? `Soll die Änderung ebenfalls in Ihr ÖAMTC-Profil übernommen werden? Sie können die ${name} auch einmalig für diesen Termin verändern.`
                  : info
              }}
            </p>
          </div>
          <slot name="action">
            <button
              :aria-expanded="expanded"
              :aria-controls="`selection-contact-expansion-${uuid}`"
              class="selection__action"
            >
              <IconEdit aria-label="Bearbeiten" v-if="!expanded" color="#737380" />
              <IconClose aria-label="Bearbeiten abbrechen" v-else />
            </button>
          </slot>
        </div>
        <hr v-if="divider && !expanded" />
      </div>
    </div>
    <div :id="`selection-contact-expansion-${uuid}`">
      <slot name="expansion" v-if="expanded" />
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/icons/IconClose.vue'
import IconEdit from '@/components/icons/IconEdit.vue'
let uuid = 0

export default {
  beforeCreate() {
    this.uuid = uuid.toString()
    uuid++
  },
  components: { IconEdit, IconClose },
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    divider: {
      type: Boolean,
      default: false,
    },
    opened: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
  data() {
    return {
      expanded: false,
    }
  },
  watch: {
    opened() {
      this.expanded = this.opened
    },
    expanded() {
      this.$emit('toggle', this.expanded)
    },
  },
  methods: {
    toggleExpanded() {
      if (this.$slots.expansion) this.expanded = !this.expanded
    },
  },
}
</script>

// scss comes from Selection.vue
